import {Component, ViewContainerRef} from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  public title = 'app works!';

  public constructor(private viewContainerRef: ViewContainerRef) {}

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/app.component.ts